export const enum ContactField {
	UniqueContactKey = 'Unique Contact Key',
	FirstName = 'First Name',
	Email = 'Email',
	PhoneNumber = 'Phone Number',
	MobileNumber = 'Mobile Number',
	Country = 'Country',
	LoyaltyStatus = 'Loyalty Status',
}
